import React, { useCallback, useState } from 'react'
import { useHistory } from 'react-router-dom'
import Icon from '../../../atoms/icon/Icon'
import API from '../../../../services/api'

import Clickable from '../../../atoms/clickable/Clickable'
import ErrorModal from '../../../organisms/standard-modal/ErrorModal'
import IconButton from '../../../molecules/iconbutton/IconButton'

interface Props {
  type: 'icon' | 'button'
  template: API.ReportingTemplateResponse
}

export const CloneReportingTemplate: React.FC<Props> = ({ type, template }) => {
  const history = useHistory()
  const [hasError, setError] = useState(false)

  const onClick = useCallback(async (event) => {
    event.stopPropagation()
    try {
      const newTemplate = await API.cloneReportingTemplate(template.id)
      history.push(`/reporting-templates/${newTemplate.id}/edit`)
    } catch (e) {
      setError(true)
    }
  }, [template.id, history])

  return <>
    {type === 'icon' &&
      <Clickable
        data-test={`clone-${template.id}`}
        onClick={onClick}>
        <Icon type='copy' tip={{
          content: (
            <>
              <b>Clone Template</b>
              <p>Create a new template using the details <br /> of this template as a starting point.</p>
            </>
          ), id: `${template.id}-copy`
        }} />
      </Clickable>
    }

    {type === 'button' &&
        <IconButton
          data-test={`clone-template-${template.id}`}
          icon='copy'
          text='Clone Template'
          onClick={onClick}
        />
    }

    {hasError && <ErrorModal
      isOpen={hasError}
      onClose={(e) => {
        e.stopPropagation()
        setError(false)
      }}
      title='Clone Template'
      description='Something went wrong when cloning the template, please try again later'
    />}
  </>
}


